<template>
    <div>
        <myHeader></myHeader>
        <div class="nav_wrap_add">
            <div class="nav_wrap">
                <div class="nav">
                    <span :class="{active:item.id==newsType}" v-for="(item,index) in news_nav" :key="index" @click="changNav(item.id)">{{item.name}}</span>
                </div>
            </div>
        </div>
        <div class="news_contain">
            <div class="news_ul">
                <div class="news_li" v-for="(item,index) in newsList" :key="index">
                    <strong @click="to_details(item.id,item.links)">{{item.title}}</strong>
                    <div class="news_li_time">
                        <span>发布时间：{{item.create_time.slice(0,11)}}</span>
                    </div>
                </div>
                <el-empty :image-size="160" v-show="!newsList.length > 0"></el-empty>
            </div>
            <div class="paging_nr" v-show="newsList.length > 0">
                <el-pagination background layout="prev, pager, next" :page-size="limit" :pager-count="5"
                               @next-click="nextClick()" @prev-click="prevClick()" @current-change="handleCurrentChange"
                               :total="counts" prev-text="上一页" next-text="下一页"></el-pagination>
            </div>
        </div>
        <myFooter></myFooter>
        <el-dialog :title="news_details.title" :visible.sync="details_flag" class="news_details" top="70px">
            <div class="details_nr" v-if="news_details.content" v-html="news_details.content"></div>
            <el-empty :image-size="160" class="details_empty" v-else></el-empty>
        </el-dialog>
    </div>
</template>

<script>
import myHeader from '../components/header.vue'
import MyFooter from '../components/footer.vue'
export default {
    name: 'news',
    components: {MyFooter, myHeader},
    data () {
        return {
            id:0,
            news_nav:[
                {name: '行业动态',id:0},
                {name: '集团新闻',id:1},
                {name: '物流政策',id:2}
            ],
            page: 0,
            newsType:0,
            newsList:[],
            details_flag:false,
            news_details:{},
            limit:10,
            counts:0
        }
    },
    created () {
        this.id = this.$route.query.id;
        this.changNav(this.id);
        this.pageNews();
    },
    methods: {
        pageNews(){
            let params = {
                page:this.page,
                pageSize:10,
                newsType:this.newsType
            };
            this.$api.newsList(params).then(res => {
                this.newsList = res.data.itemList;
                this.counts = res.data.counts;
            });
        },
        to_details(id,links){
            console.log(links);
            if(links){
                window.open(links, '_blank')
            }else{
                this.details_flag = true;
                let params = {
                    id:id
                };
                this.$api.newsDetail(params).then(res => {
                    this.news_details = res.data;
                });
            }
        },
        changNav(id){
            this.newsType = id;
            this.pageNews();
        },
        nextClick(){
            this.page++;
            this.pageNews();
        },
        prevClick(){
            this.page--;
            this.pageNews();
        },
        handleCurrentChange(val){
            this.page=val;
            this.pageNews();
        },
    }
}
</script>

<style scoped>
.nav_wrap_add{width:100%;height:70px;display:block;float:left;}
.nav_wrap{width:100%;height:70px;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 70px;
    position:fixed;left:0;top:90px;z-index:99;}
.nav{width:1200px;height:70px;display:flex;margin:0 auto;justify-content: center;}
.nav span{width:130px;height:70px;border-bottom:3px solid;border-color:transparent;padding:0 30px;text-align:center;
    font-size:15px;color:#fff;float:left;margin:0 2px;cursor:pointer; align-items: center;justify-content: center;display: inline-flex;
}
.nav span:hover{color:#fff;}
.nav span.active{color:#fff;border-color:#fff;}
.news_contain{width:1200px;height:auto;min-height:300px;float:left;position:relative;left:50%;margin-left:-600px;padding:40px 0 60px;}
.news_ul{width:100%;height:auto;float:left;min-height:400px;}
.news_ul .news_li{width:100%;height:auto;padding:15px 0 10px;border-bottom:1px solid #ededed;float:left;}
.news_li strong{width:70%;height:auto;font-size:15px;color:#333;line-height:30px;display:inline-block;float:left;cursor:pointer;font-weight:normal;}
.news_li strong:hover{color:#0c57c3;}
.news_li .news_li_time{width:30%;height:30px;display:inline-block;float:left;}
.news_li .news_li_time span{width:100%;height:30px;font-size:12px;color:#999;line-height:30px;display:block;float:left;text-align:right;}
.paging_nr{width:100%;height:32px;display:block;overflow:hidden;text-align:center;float:left;margin-top:40px;}
/deep/ .paging_nr .el-pager li{background:transparent;border:1px solid #ddd;line-height:26px;color:#333;font-weight: normal;}
/deep/ .paging_nr .el-pagination.is-background .el-pager li:not(.disabled).active{background:#0c57c3;color:#fff;border-color:#0c57c3;}
/deep/ .paging_nr .el-pagination.is-background .el-pager li:not(.disabled):hover{color:#6f5a2d;}
/deep/ .paging_nr .el-pagination.is-background .btn-next{background:#0c57c3;color:#fff;border:1px solid #0c57c3;padding:0 10px;}
/deep/ .paging_nr .el-pagination.is-background .btn-next span{line-height:26px;height:26px;}
/deep/ .paging_nr .el-pagination.is-background .btn-prev{background:#0c57c3;color:#fff;border:1px solid #0c57c3;padding:0 10px;}
/deep/ .paging_nr .el-pagination.is-background .btn-prev span{line-height:26px;height:26px;}
/deep/ .paging_nr .el-pagination.is-background .btn-next:disabled{background:#eee;color:#333;border:1px solid #ddd;}
/deep/ .paging_nr .el-pagination.is-background .btn-prev:disabled{background:#eee;color:#333;border:1px solid #ddd;}
/deep/ .paging_nr .el-pagination.is-background .el-pager li:not(.disabled):hover{color:#fff;}
.news_details{width:100%;}
/deep/ .news_details .el-dialog{width:1200px;height:800px;margin-top:70px;}
/deep/ .news_details .el-dialog__header{text-align:center;}
/deep/ .news_details .el-dialog__title{font-weight:bold;}
/deep/ .news_details .el-dialog__body{border-top:1px solid #eee;padding:20px 50px 30px;}
.details_nr{width:100%;height:700px;float:left;font-size:14px;color:#333;line-height:24px;overflow:hidden;overflow-y:scroll;}
.details_nr img{max-width:100%;height:auto;display:block;}
.details_nr::-webkit-scrollbar {width:0;height:0;}
.details_nr::-webkit-scrollbar-thumb {
    background: transparent;
}
.details_nr::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: transparent;
}
.details_empty{margin-top:100px;}
@media (min-width:992px) and (max-width:1200px){
    .nav_wrap_add{height:60px;}
    .nav_wrap{height:60px;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 60px;top:80px;}
    .nav{width:1000px;height:60px;}
    .nav span{height:60px;border-bottom:2px solid;border-color:transparent;padding:0 25px;font-size:15px;line-height:58px;margin:0 10px;}
    .news_contain{width:1000px;min-height:300px;margin-left:-500px;padding:30px 0 50px;}
    .news_ul{min-height:300px;}
    .news_ul .news_li{padding:14px 0 6px;}
    .news_li strong{width:70%;font-size:14px;line-height:24px;}
    .news_li .news_li_time{width:30%;height:24px;}
    .news_li .news_li_time span{height:24px;line-height:24px;}
    .paging_nr{width:100%;height:32px;display:block;overflow:hidden;text-align:center;float:left;margin-top:40px;}
    /deep/ .paging_nr .el-pager li{background:transparent;border:1px solid #ddd;line-height:26px;color:#333;font-weight: normal;}
    /deep/ .paging_nr .el-pagination.is-background .btn-next{background:#0c57c3;color:#fff;border:1px solid #0c57c3;padding:0 10px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-next span{line-height:26px;height:26px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-prev{background:#0c57c3;color:#fff;border:1px solid #0c57c3;padding:0 10px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-prev span{line-height:26px;height:26px;}
    /deep/ .news_details .el-dialog{width:800px;height:600px;margin-top:70px;}
    /deep/ .news_details .el-dialog__body{border-top:1px solid #eee;padding:15px 40px 30px;}
    .details_nr{width:100%;height:500px;float:left;font-size:14px;color:#333;line-height:24px;overflow:hidden;overflow-y:scroll;}
    .details_empty{margin-top:50px;}
}
@media (min-width:768px) and (max-width:991px){
    .nav_wrap_add{height:50px;}
    .nav_wrap{height:50px;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 50px;top:70px;}
    .nav{width:750px;height:50px;}
    .nav span{height:50px;border-bottom:2px solid;border-color:transparent;padding:0 20px;font-size:14px;line-height:48px;margin:0 5px;}
    .news_contain{width:750px;min-height:200px;margin-left:-375px;padding:20px 0 40px;}
    .news_ul{min-height:200px;}
    .news_ul .news_li{padding:14px 0 6px;}
    .news_li strong{width:70%;font-size:14px;line-height:24px;}
    .news_li .news_li_time{width:30%;height:24px;}
    .news_li .news_li_time span{height:24px;line-height:24px;}
    .paging_nr{width:100%;height:32px;display:block;overflow:hidden;text-align:center;float:left;margin-top:40px;}
    /deep/ .paging_nr .el-pager li{background:transparent;border:1px solid #ddd;line-height:26px;color:#333;font-weight: normal;}
    /deep/ .paging_nr .el-pagination.is-background .btn-next{background:#0c57c3;color:#fff;border:1px solid #0c57c3;padding:0 10px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-next span{line-height:26px;height:26px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-prev{background:#0c57c3;color:#fff;border:1px solid #0c57c3;padding:0 10px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-prev span{line-height:26px;height:26px;}
    /deep/ .news_details .el-dialog{width:600px;height:500px;margin-top:50px;}
    /deep/ .news_details .el-dialog__body{border-top:1px solid #eee;padding:15px 30px 30px;}
    .details_nr{width:100%;height:400px;float:left;font-size:14px;color:#333;line-height:24px;overflow:hidden;overflow-y:scroll;}
    .details_empty{margin-top:40px;}
}
@media (max-width:767px){
    .nav_wrap_add{display:none;}
    .nav_wrap{display:none;}
    .news_contain{width:100%;min-height:400px;margin-left:0;padding:20px 15px 30px;left:0;}
    .news_ul{min-height:400px;}
    .news_ul .news_li{padding:14px 0 6px;}
    .news_li strong{width:60%;font-size:14px;line-height:24px;}
    .news_li .news_li_time{width:40%;height:24px;}
    .news_li .news_li_time span{height:24px;line-height:24px;}
    .paging_nr{width:100%;height:30px;display:block;overflow:hidden;text-align:center;float:left;margin-top:30px;}
    /deep/ .paging_nr .el-pager li{background:transparent;border:1px solid #ddd;line-height:24px;color:#333;font-weight: normal;}
    /deep/ .paging_nr .el-pagination.is-background .btn-next{background:#0c57c3;color:#fff;border:1px solid #0c57c3;padding:0 10px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-next span{line-height:24px;height:24px;font-size:12px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-prev{background:#0c57c3;color:#fff;border:1px solid #0c57c3;padding:0 10px;}
    /deep/ .paging_nr .el-pagination.is-background .btn-prev span{line-height:24px;height:24px;font-size:12px;}
    .news_details{width:90%;left:5%;right:5%;}
    /deep/ .news_details .el-dialog{width:100%;height:500px;margin-top:50px;}
    /deep/ .news_details .el-dialog__body{border-top:1px solid #eee;padding:15px 15px 30px;}
    .details_nr{width:100%;height:400px;float:left;font-size:14px;color:#333;line-height:24px;overflow:hidden;overflow-y:scroll;}
    .details_empty{margin-top:0;}
}
</style>



// WEBPACK FOOTER //
// src/pages/news.vue